import { pressedEnter } from '../../utils';
import { Filter, FilterFacet } from './types';

const Checkbox = ({
  facet,
  callback,
  hideLabel,
}: {
  facet: FilterFacet;
  callback: () => void;
  hideLabel?: boolean;
}) => {
  return (
    <label className="filters__input-wrapper">
      <input
        className="filters__input"
        type="checkbox"
        checked={Boolean(facet.selected)}
        onChange={callback}
        onKeyDown={e => pressedEnter(e, () => callback())}
      />
      {!hideLabel ? <span>{facet.name}</span> : null}
    </label>
  );
};

const AllCheckbox = ({
  filter,
  callback,
}: {
  filter: Filter;
  callback: () => void;
}) => {
  const selected = filter.facets.every(facet => facet.selected);

  if (filter.facets.length <= 1) return null;

  return (
    <Checkbox
      facet={{
        id: filter.name,
        name: filter.allLabel,
        selected,
      }}
      callback={callback}
    />
  );
};

Checkbox.SelectAll = AllCheckbox;

export default Checkbox;
